/** CSS contract: css-library/components/02-containers/stack-list.css. */
import type { Ref } from 'react';
import type { HTMLAttributes, LiHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';
import { ButtonControl } from './ButtonControl';
import { Icon } from './Icon';

export interface StackListProps extends HTMLAttributes<HTMLUListElement> {
  scroll?: boolean;
}

export function StackList(
  { ref, scroll = false, className, children, ...rest }: StackListProps & { ref?: Ref<HTMLUListElement> },
) {
  return (
    <ul ref={ref} className={cx('stack-list', scroll && 'is-scroll', className)} {...rest}>
      {children}
    </ul>
  );
}

export interface StackListItemProps extends LiHTMLAttributes<HTMLLIElement> {
  end?: ReactNode;
}

export function StackListItem(
  { ref, end, className, children, ...rest }: StackListItemProps & { ref?: Ref<HTMLLIElement> },
) {
  return (
    <li ref={ref} className={cx('stack-list-item', className)} {...rest}>
      {children}
      {end != null && <span className="stack-list-end">{end}</span>}
    </li>
  );
}

export type StackListValueProps = HTMLAttributes<HTMLSpanElement>;

export function StackListValue(
  { ref, className, children, ...rest }: StackListValueProps & { ref?: Ref<HTMLSpanElement> },
) {
  return (
    <span ref={ref} className={cx('stack-list-value', className)} {...rest}>
      {children}
    </span>
  );
}

export function StackListAction({ children, onClick }: { children: ReactNode; onClick: () => void }) {
  return (
    <li className="stack-list-item stack-list-item--action">
      <ButtonControl type="button" className="stack-list-action" onClick={onClick}>
        <span className="stack-list-value">{children}</span>
        <span className="stack-list-end"><Icon name="i-chevron-right" /></span>
      </ButtonControl>
    </li>
  );
}
